import { useEffect, useRef, useState } from "react";
import { IoCheckmarkCircle } from "react-icons/io5";
import {
  getAllCleanerShifts,
  getuserinformation,
  savereminderdata,
  savevehicledata,
  updateItem,
} from "../../utils/firebasefunctions";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { MdEditDocument, MdDelete } from "react-icons/md";
import { getStorage, ref, deleteObject } from "firebase/storage";
import userlogo from "../images/user.png";
import { RotatingLines } from "react-loader-spinner";
import { IoIosCloseCircle } from "react-icons/io";
import { actionType } from "../context/reducer";
import { ToastContainer, toast } from "react-toastify";
import { FaCircleMinus } from "react-icons/fa6";
import carlogo from "../images/car.png";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import { FaCar } from "react-icons/fa";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import {
  arrayUnion,
  collection,
  doc,
  onSnapshot,
  query,
} from "firebase/firestore";
import { firestored, storage } from "../../firebase.config";

import { useStateValue } from "../context/StateProvider";
import EmployeePopup from "./EmployeePopup";

const containerStyle = {
  width: "100%",
  minHeight: "100%",
};

const VehicleHistory = (props) => {
  const [{ user, employees }, dispatch] = useStateValue();
  const [employeedata, setemployeedata] = useState();
  const [employeepopup, setemployeepopup] = useState(false);
  const [remindertime, setremindertime] = useState("12:00");
  const [selectedemployee, setselectedemployee] = useState([]);
  const [taskloader, settaskloader] = useState(false);
  const [loader, setloader] = useState(false);
  const [gallerycounter, setgallerycounter] = useState(0);
  const [galleryviewmodel, setgalleryviewmodel] = useState(false);
  const [galleryviewdata, setgalleryviewdata] = useState([]);

  const [newtask, setnewtask] = useState("");
  const [selecteddate, setselecteddate] = useState(new Date());

  const popupref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        props.activateoutsidecontainerclick();
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupref]);

  const Heading = (title) => {
    return <p className="pt-[10px] PoppinsRegular  text-textcolor ">{title}</p>;
  };

  async function deletereminder(id, index) {
    let dataset = {
      delete: true,
    };
    await updateItem("reminders", id, dataset)
      .then(async (response) => {
        if (response == "success") {
          let newdata = [...props.data];
          newdata.splice(index, 1);
          props.updatereminders(newdata);
        } else {
          toast.warn("Something went wrong. Please try again later!");
        }
      })
      .catch((error) => {
        toast.warn("Something went wrong. Please try again later!");
      });
  }

  async function updateslot(id, data) {
    await updateItem("slots", id, data)
      .then(async (response) => {
        if (response == "success") {
          props.refetchlist();
        } else {
          toast.warn("Something went wrong. Please try again later!");
        }
      })
      .catch((error) => {
        toast.warn("Something went wrong. Please try again later!");
      });
  }

  function getStoragePathFromUrl(url) {
    const match = url.match(/\/o\/(.*?)\?/);
    if (!match || !match[1]) return null;

    return decodeURIComponent(match[1]); // e.g., vehichlepicture/abc.jpg
  }
  const deleteImage = async (filePath, index, arraytype, obj) => {
    // const storagePath = getStoragePathFromUrl(filePath);
    // if (!storagePath) {
    //   alert("Could not extract path from URL");
    //   return;
    // }

    const storage = getStorage();
    const fileRef = ref(storage, filePath);

    try {
      await deleteObject(fileRef);

      if (arraytype == "in") {
        let newarray = [...obj.vehiclecheckinimages];

        newarray.splice(index, 1);
        let data = {
          vehiclecheckinimages: newarray,
        };
        updateslot(obj.schedulecreationdate, data);
      } else {
        let newarray = [...obj.vehiclecheckoutimages];

        newarray.splice(index, 1);
        let data = {
          vehiclecheckoutimages: newarray,
        };
        updateslot(obj.schedulecreationdate, data);
      }
      //   setgalleryviewdata(data);
      toast.success("Image deleted successfully");
      console.log("File deleted successfully");
    } catch (error) {
      console.error("Error deleting file:", error);
      toast.warn("Image file has already been deleted. Removing from slot...");
      if (arraytype == "in") {
        let newarray = [...obj.vehiclecheckinimages];

        newarray.splice(index, 1);
        let data = {
          vehiclecheckinimages: newarray,
        };
        updateslot(obj.schedulecreationdate, data);
      } else {
        let newarray = [...obj.vehiclecheckoutimages];

        newarray.splice(index, 1);
        let data = {
          vehiclecheckoutimages: newarray,
        };
        updateslot(obj.schedulecreationdate, data);
      }
      //   alert("Error deleting file: " + error.message);
    }
  };
  return (
    props.visible && (
      <div className="position absolute z-10  top-[0] left-[0] w-full h-full bg-[rgba(211,211,211,0.4)] flex items-center justify-center ">
        <div
          ref={popupref}
          className="w-[80%] lg:w-[900px]   bg-themeColor border border-bordercolor  rounded-xl  gk-scr  flex items-center justify-center flex-col   h-[80%] md:h-[90%] px-[20px] "
        >
          <div className="flex w-full h-[100%] relative flex-col py-[20px]  overflow-scroll ">
            {Heading("Vehicle History")}
            <div className=" overflow-x-auto  border border-bordercolor mt-5  bg-cardOverlay rounded-xl  drop-shadow-lg overflow-y-scroll m-h-[45%] ">
              <table className="min-w-full divide-y divide-bordercolor bg-themelightblack text-sm">
                <thead className="ltr:text-left rtl:text-right">
                  <tr>
                    <th className="whitespace-nowrap py-2 px-2  PoppinsRegular text-textcolor w-[50px]"></th>
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor/80">
                      Driver name
                    </th>
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor/80">
                      Shift Status
                    </th>
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor/80">
                      Date
                    </th>
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor/80">
                      Time Slot
                    </th>
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor/80">
                      Trip Start Mileage
                    </th>
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor/80">
                      Trip Start Images
                    </th>
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor/80">
                      Trip End Mileage
                    </th>
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor/80">
                      Trip End Images
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-bordercolor text-center">
                  {props.data &&
                    props.data.map((item, index) => (
                      <tr
                        key={index.toString()}
                        className="hover:bg-[#0989B826]/10 cursor-pointer h-[90px]"
                        onClick={() => {}}
                      >
                        <td className="whitespace-nowrap px-4 py-2">
                          <div className="flex flex-row w-[50px] ">
                            {employees
                              .filter((x) => item.employeeid == x.id)
                              .map((itemdata, ind) => {
                                return (
                                  <img loading="lazy"
                                    style={{
                                      marginLeft: 5,
                                      //   marginLeft:
                                      //     employees.filter(
                                      //       (x) =>
                                      //         item.employeelist.find(
                                      //           (item) => item == x.id
                                      //         ) != undefined
                                      //     ).length > 1
                                      //       ? -50
                                      //       : 0,
                                    }}
                                    src={
                                      itemdata.profilepicture
                                        ? itemdata.profilepicture
                                        : userlogo
                                    }
                                    className="w-[35px] h-[35px] rounded-full object-cover"
                                  />
                                );
                              })}
                          </div>
                        </td>
                        <td className="whitespace-nowrap py-2 PoppinsRegular  text-textcolor text-center">
                          {employees
                            .filter((x) => item?.employeeid == x.id)
                            .map((itemdata, ind) => {
                              return (
                                <p>
                                  {itemdata.firstname} {itemdata.lastname}
                                </p>
                              );
                            })}
                        </td>
                        <td className="whitespace-nowrap  py-2 PoppinsRegular  text-textcolor text-center ">
                          <p
                            className={`PoppinsRegular  text-[15px] ${
                              item?.checkoutdatetime
                                ? "text-red-500"
                                : item?.checkindatetime
                                ? "text-textcolor"
                                : "text-orange-500"
                            } `}
                          >
                            {item.workerstatus}
                          </p>
                        </td>
                        <td className="whitespace-nowrap pl-4 py-2 PoppinsRegular  text-textcolor text-center ">
                          {item.sheduleddate}
                        </td>
                        <td className="whitespace-nowrap pl-4 py-2 PoppinsRegular  text-textcolor text-center ">
                          {item.timeslot}
                        </td>
                        <td className="whitespace-nowrap pl-4 py-2 PoppinsRegular  text-textcolor text-center ">
                          {item.vehiclecheckinkms
                            ? `${item.vehiclecheckinkms} KM's`
                            : "NA"}
                        </td>
                        <td className="whitespace-nowrap pl-4 py-2 PoppinsRegular  text-textcolor text-center hover:text-textcolor  hover:underline hover:cursor-pointer">
                          <div className=" flex flex-row w-[180px]">
                            {item?.vehiclecheckinimages?.length > 0 &&
                              item?.vehiclecheckinimages.map(
                                (itemdata, index) => (
                                  <div className="flex relative flex-col  ">
                                    <img loading="lazy"
                                      onClick={() => {
                                        setgalleryviewdata(
                                          item?.vehiclecheckinimages
                                        );
                                        setgallerycounter(index);
                                        setgalleryviewmodel(true);
                                      }}
                                      src={itemdata}
                                      className=" h-[40px] w-[40px]   object-cover rounded-md mr-[5px] "
                                    />
                                    <div
                                      onClick={() => {
                                        deleteImage(
                                          itemdata,
                                          index,
                                          "in",
                                          item
                                        );
                                      }}
                                      className="   rounded-full flex  items-center justify-center mt-[4px]  "
                                    >
                                      <MdDelete className=" text-textcolor w-[15px] h-[15px] hover:cursor-pointer hover:text-red-500" />
                                    </div>
                                  </div>
                                )
                              )}
                          </div>
                        </td>
                        <td className="whitespace-nowrap pl-4 py-2 PoppinsRegular  text-textcolor text-center ">
                          {item.vehiclecheckoutkms
                            ? `${item.vehiclecheckoutkms} KM's`
                            : "NA"}
                        </td>
                        <td className="whitespace-nowrap pl-4 py-2 PoppinsRegular  text-textcolor text-center hover:text-textcolor hover:underline hover:cursor-pointer">
                          <div className=" flex flex-row  w-[180px]">
                            {item?.vehiclecheckoutimages?.length > 0 &&
                              item?.vehiclecheckoutimages.map(
                                (itemdata, index) => (
                                  <div className="flex relative flex-col">
                                    <img loading="lazy"
                                      onClick={() => {
                                        setgalleryviewdata(
                                          item?.vehiclecheckoutimages
                                        );
                                        setgallerycounter(index);
                                        setgalleryviewmodel(true);
                                      }}
                                      src={itemdata}
                                      className=" h-[40px] w-[40px]   object-cover rounded-md mr-[5px] "
                                    />
                                    <div
                                      onClick={() => {
                                        deleteImage(
                                          itemdata,
                                          index,
                                          "out",
                                          item
                                        );
                                      }}
                                      className="   rounded-full flex  items-center justify-center mt-[4px]  "
                                    >
                                      <MdDelete className=" text-textcolor w-[15px] h-[15px] hover:cursor-pointer hover:text-red-500" />
                                    </div>
                                  </div>
                                )
                              )}
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {galleryviewmodel && (
              <div className=" fixed z-10  top-[0] left-[0] w-full h-screen border border-bordercolor  rounded-xl  gk-scr  flex items-center justify-center flex-col overflow-hidden  ">
                <div className=" w-full h-full bg-black flex items-center justify-center p-[50px] ">
                  <div className="w-full h-full flex items-center justify-center relative">
                    <div
                      onClick={() => {
                        if (gallerycounter == 0) {
                          setgallerycounter(galleryviewdata.length - 1);
                        } else {
                          let newcount = gallerycounter - 1;
                          setgallerycounter(newcount);
                        }
                      }}
                      className=" hover:cursor-pointer position absolute left-0"
                    >
                      <IoIosArrowBack className="   w-[50px] h-[50px]  text-white" />
                    </div>
                    <div
                      onClick={() => {
                        if (gallerycounter < galleryviewdata.length - 1) {
                          let newcount = gallerycounter + 1;
                          setgallerycounter(newcount);
                        } else {
                          setgallerycounter(0);
                        }
                      }}
                      className="hover:cursor-pointer position absolute right-0"
                    >
                      <IoIosArrowForward className="   w-[50px] h-[50px] position absolute right-0 text-white" />
                    </div>

                    <div
                      onClick={() => {
                        setgalleryviewdata([]);
                        setgallerycounter(0);
                        setgalleryviewmodel(false);
                      }}
                      className=" h-[50px] w-[50px]  rounded-full flex  items-center justify-center position absolute right-[-5px] top-[-5px]"
                    >
                      <IoIosCloseCircle className=" text-white  w-[30px] h-[30px] hover:cursor-pointer" />
                    </div>

                    <img loading="lazy"
                      src={galleryviewdata[gallerycounter]}
                      className="w-full h-full object-contain rounded-md "
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default VehicleHistory;
